import React from 'react';
import useStyles from './styles';

export interface ColorfulProgressProps {
    size?: number;
}

const Spin = ({ size }: ColorfulProgressProps) => (
    <svg height={size} width={size} viewBox="5 5 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="30" stroke="url(#paint0_linear)" strokeWidth="6" />
        <defs>
            <linearGradient id="paint0_linear" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBE53B" />
                <stop offset="0.17" stopColor="#FF4F01" />
                <stop offset="0.35" stopColor="#FF14B3" />
                <stop offset="0.55" stopColor="#8000FF" />
                <stop offset="0.8" stopColor="#00C1FF" />
                <stop offset="1" stopColor="#17F036" />
            </linearGradient>
        </defs>
    </svg>
);

const ColorfulProgress: React.FC<ColorfulProgressProps> = ({ size = 48 }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Spin size={size} />
        </div>
    );
};

export default ColorfulProgress;
